import styled, { css } from 'styled-components';
import { regularOutline } from './typography/helpers';

export const ClearFix = css`
    &:after {
        content: '';
        clear: both;
        display: table;
    }
`;

export const PlayFocus = css`
    outline: none;

    &:focus {
        ${regularOutline()}
    }

    &:focus-visible {
        ${regularOutline()}
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }
`;

export const VisuallyHidden = css`
    position: absolute !important; /* stylelint-disable-line declaration-no-important */
    overflow: hidden;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    outline: 0;
`;

export const VisuallyHiddenStyle = styled.p`
    ${VisuallyHidden}
`;

export const placeholderColor = (color) => css`
    &::-webkit-input-placeholder {
        color: ${color};
    }
    &::-moz-placeholder {
        color: ${color};
    }
    &:-moz-placeholder {
        color: ${color};
    }
    &:-ms-input-placeholder {
        color: ${color};
    }
`;
